import { select, call } from 'redux-saga/effects';
import get from 'lodash/get';
import find from 'lodash/find';
import { isFeatureEnabledFromCookie } from 'yoda-core-components/lib/helpers/Utils/Utils';

const contextSelector = (state) => state.context;
const shipToHomeInfoSelector = (state) => state.newShipping.shipToHomeInfo;
const userAddressListSelector = (state) => state.newShipping.shipToHomeInfo.userAddressList;
const newShippingSelector = (state) => state.newShipping;

export function* isGoogleAddressValidationEnabled() {
    const context = yield select(contextSelector);
    const enableGoogleAddressValidation = get(
        context,
        'featureFlags.enableGoogleAddressValidation',
        false
    );
    return isFeatureEnabledFromCookie('enableGAV') || enableGoogleAddressValidation;
}

/** If no address is added to order, re-adds the selected address to order */
export function* reapplyAddressOnGavSoftBlock(isUserLoggedIn, changeShippingAddressToOrder) {
    const newShipping = yield select(newShippingSelector);

    const hasGavSoftBlock = newShipping?.shipToHomeInfo?.gavError?.softBlock;
    if (hasGavSoftBlock && newShipping.shippingType === 'HOME') {
        const userAddressList = yield select(userAddressListSelector);
        const selectedAddress = find(userAddressList, { selected: true });
        if (selectedAddress) {
            const action = {
                address: selectedAddress,
                IsFromReapplySoftCheckAddress: true,
                cutomerAddressVerified: true,
            };
            const isAddressUpdated = yield call(changeShippingAddressToOrder, action);
            return isAddressUpdated;
        }
    }
    return true;
}
